import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

import { Select2Module } from 'ng2-select2';

import { SharedModule } from '../shared/shared.module';

import { AuthRoutingModule } from './auth-routing.module';

import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import { AuthContractComponent } from './auth-contract/auth-contract.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RegisterComponent } from './register/register.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { RegisterUserQuestionComponent } from './register-user-question/register-user-question.component';
import { RegisterUserMessageComponent } from './register-user-message/register-user-message.component';
import { LoginMpComponent } from './login-mp/login-mp.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    AuthRoutingModule,
    SharedModule,
    Select2Module
  ],
  declarations: [LoginComponent, AuthComponent, AuthContractComponent, ForgotPasswordComponent, RegisterComponent, RegisterUserComponent, RegisterUserQuestionComponent, RegisterUserMessageComponent, LoginMpComponent]
})
export class AuthModule { }



// WEBPACK FOOTER //
// /app/src/app/auth/auth.module.ts